const UseFooter = () => {
  const ScrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return { ScrollToTop };
};

export default UseFooter;
